import { Button, Grid, Typography } from "@mui/material";

export default function Thankyou({ onBookAnother }) {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
      }}
    >
      <Typography color="red" align="center" mb={5}>
        To amend or cancel an existing job please call: 0770 014 5577 and select
        Option 3.
      </Typography>
      <Typography variant="h6" align="center" mb={5}>
        Look out for emails and texts with instructions on how to prepare and
        what to do if you need to amend your booking.
      </Typography>
      <Typography variant="h6" align="center" mb={5}>
        All bookings are screened by a human. If there are any issues we will
        contact you directly.
      </Typography>
      <Button size="small" variant="contained" onClick={onBookAnother}>
        Quote & Book Another job
      </Button>
      <Grid mt={2} width={255}>
        <Button
          fullWidth
          size="small"
          variant="contained"
          onClick={() => (window.location.href = "https://smuve.uk")}
        >
          Home
        </Button>
      </Grid>
    </div>
  );
}
